module.exports = __webpack_public_path__ + "static/media/Air-pollution-very-low.3cdc88db.svg";